var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatFaceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67732 12.3757C3.49102 12.8536 3.91962 12.7201 4.24265 13.1882C4.27968 13.242 4.46956 13.5166 4.43096 13.8686C4.40102 14.1493 4.23793 14.3663 4.13629 14.4611C3.51544 15.04 1.80575 14.3322 0.826412 13.5568C0.612897 13.3877 0.0401087 12.9348 0.155927 12.6131C0.2032 12.4811 0.349745 12.4159 0.455321 12.3704C0.920957 12.1701 1.40393 12.3028 1.67732 12.3749V12.3757Z",
    fill: "#D2042D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27669 0.638672H6.89062V3.07764H7.27669V0.638672Z",
    fill: "#AA0433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41214 2.82227H5.74675C5.55007 2.82227 5.39062 2.97579 5.39062 3.16516V4.08233C5.39062 4.27171 5.55007 4.42523 5.74675 4.42523H8.41214C8.60882 4.42523 8.76826 4.27171 8.76826 4.08233V3.16516C8.76826 2.97579 8.60882 2.82227 8.41214 2.82227Z",
    fill: "#AA0433"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99561 3.58789H8.167C10.9033 3.58789 13.1243 5.72644 13.1243 8.36113V9.75472C13.1243 11.2355 11.8755 12.4372 10.3384 12.4372H3.825C2.28706 12.4372 1.03906 11.2348 1.03906 9.75472V8.36113C1.03906 5.72644 3.26009 3.58789 5.9964 3.58789H5.99561Z",
    fill: "#D2042D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2271 9.5014C11.0687 9.57651 10.8914 9.61596 10.7118 9.61596H3.45939C3.27896 9.61596 3.10169 9.57651 2.94412 9.5014C2.55569 9.3163 2.33666 8.94306 2.39103 8.55996L2.39496 8.53189C2.5809 7.23465 3.80133 6.23706 5.29672 6.16271C5.92939 6.13085 6.59357 6.11492 7.2869 6.11871C7.82975 6.12175 8.35448 6.13692 8.85951 6.16196C10.3612 6.2363 11.5903 7.23009 11.777 8.53189C11.7786 8.54099 11.7794 8.55085 11.781 8.55996C11.8361 8.94306 11.6163 9.3163 11.2279 9.5014H11.2271Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M5.17245 9.33022C5.92784 9.33022 6.5402 8.74059 6.5402 8.01325C6.5402 7.28591 5.92784 6.69629 5.17245 6.69629C4.41705 6.69629 3.80469 7.28591 3.80469 8.01325C3.80469 8.74059 4.41705 9.33022 5.17245 9.33022Z",
    fill: "url(#paint0_radial_40011309_16249)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1692 8.95884C5.71137 8.95884 6.15089 8.53564 6.15089 8.0136C6.15089 7.49156 5.71137 7.06836 5.1692 7.06836C4.62702 7.06836 4.1875 7.49156 4.1875 8.0136C4.1875 8.53564 4.62702 8.95884 5.1692 8.95884Z",
    fill: "#EEFDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16787 8.80676C5.62302 8.80676 5.99199 8.45149 5.99199 8.01324C5.99199 7.575 5.62302 7.21973 5.16787 7.21973C4.71272 7.21973 4.34375 7.575 4.34375 8.01324C4.34375 8.45149 4.71272 8.80676 5.16787 8.80676Z",
    fill: "url(#paint1_linear_40011309_16249)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69733 7.80802C5.69733 7.97036 5.56024 8.10236 5.39163 8.10236C5.22303 8.10236 5.08594 7.97036 5.08594 7.80802C5.08594 7.64567 5.22303 7.51367 5.39163 7.51367C5.56024 7.51367 5.69733 7.64567 5.69733 7.80802Z",
    fill: "#EEFDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05181 8.73908C5.11925 8.73908 5.17393 8.68643 5.17393 8.62149C5.17393 8.55655 5.11925 8.50391 5.05181 8.50391C4.98436 8.50391 4.92969 8.55655 4.92969 8.62149C4.92969 8.68643 4.98436 8.73908 5.05181 8.73908Z",
    fill: "#EEFDFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74633 8.44611C4.74633 8.47873 4.71876 8.50452 4.68567 8.50452C4.65257 8.50452 4.625 8.47797 4.625 8.44611C4.625 8.41425 4.65257 8.3877 4.68567 8.3877C4.71876 8.3877 4.74633 8.41425 4.74633 8.44611Z",
    fill: "#EEFDFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M8.86776 9.33022C9.62315 9.33022 10.2355 8.74059 10.2355 8.01325C10.2355 7.28591 9.62315 6.69629 8.86776 6.69629C8.11237 6.69629 7.5 7.28591 7.5 8.01325C7.5 8.74059 8.11237 9.33022 8.86776 9.33022Z",
    fill: "url(#paint2_radial_40011309_16249)"
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86451 8.95884C9.40669 8.95884 9.84621 8.53564 9.84621 8.0136C9.84621 7.49156 9.40669 7.06836 8.86451 7.06836C8.32233 7.06836 7.88281 7.49156 7.88281 8.0136C7.88281 8.53564 8.32233 8.95884 8.86451 8.95884Z",
    fill: "#EEFDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86318 8.80676C9.31833 8.80676 9.6873 8.45149 9.6873 8.01324C9.6873 7.575 9.31833 7.21973 8.86318 7.21973C8.40803 7.21973 8.03906 7.575 8.03906 8.01324C8.03906 8.45149 8.40803 8.80676 8.86318 8.80676Z",
    fill: "url(#paint3_linear_40011309_16249)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39264 7.80802C9.39264 7.97036 9.25555 8.10236 9.08695 8.10236C8.91834 8.10236 8.78125 7.97036 8.78125 7.80802C8.78125 7.64567 8.91834 7.51367 9.08695 7.51367C9.25555 7.51367 9.39264 7.64567 9.39264 7.80802Z",
    fill: "#EEFDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74712 8.73908C8.81457 8.73908 8.86924 8.68643 8.86924 8.62149C8.86924 8.55655 8.81457 8.50391 8.74712 8.50391C8.67967 8.50391 8.625 8.55655 8.625 8.62149C8.625 8.68643 8.67967 8.73908 8.74712 8.73908Z",
    fill: "#EEFDFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44165 8.44611C8.44165 8.47873 8.41407 8.50452 8.38098 8.50452C8.34789 8.50452 8.32031 8.47797 8.32031 8.44611C8.32031 8.41425 8.34789 8.3877 8.38098 8.3877C8.41407 8.3877 8.44165 8.41425 8.44165 8.44611Z",
    fill: "#EEFDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57551 0.476414C7.57551 0.739655 7.35412 0.952828 7.08073 0.952828C6.80733 0.952828 6.58594 0.739655 6.58594 0.476414C6.58594 0.213172 6.80733 0 7.08073 0C7.35412 0 7.57551 0.213172 7.57551 0.476414Z",
    fill: "#AA0433"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42597 0.290404C7.42597 0.370818 7.35821 0.435301 7.27548 0.435301C7.19276 0.435301 7.125 0.37006 7.125 0.290404C7.125 0.210749 7.19276 0.145508 7.27548 0.145508C7.35821 0.145508 7.42597 0.210749 7.42597 0.290404Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3414 5.11514C11.3477 5.33741 11.1594 5.60293 10.9436 5.62569C10.7411 5.64693 10.5796 5.44817 10.4133 5.24259C10.2494 5.04003 9.89016 4.52038 10.0328 4.37321C10.2211 4.179 11.3265 4.59017 11.3414 5.11438V5.11514Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49207 4.26826C9.58693 4.26826 9.66383 4.19422 9.66383 4.10288C9.66383 4.01154 9.58693 3.9375 9.49207 3.9375C9.39721 3.9375 9.32031 4.01154 9.32031 4.10288C9.32031 4.19422 9.39721 4.26826 9.49207 4.26826Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3129 8.19884C11.2578 8.23601 10.8733 7.48194 9.84116 6.82877C9.47874 6.59891 9.12025 6.43505 9.14153 6.38725C9.1628 6.3387 9.56619 6.42898 9.88922 6.57312C10.9182 7.03284 11.3783 8.15484 11.3121 8.19884H11.3129Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67062 3.29601C8.65801 3.29753 8.65013 3.2285 8.59026 3.12077C8.59026 3.12077 8.56189 3.0707 8.52959 3.02822C8.42559 2.89091 8.07498 2.89395 8.04741 2.89395C7.50062 2.8985 7.14844 2.86512 7.14844 2.86815C7.14844 2.87119 7.40529 2.86588 7.5928 2.86208C8.12304 2.85146 8.43898 2.82415 8.5745 2.9607C8.63044 3.0176 8.6588 3.09119 8.6588 3.09119C8.69741 3.19133 8.68401 3.29374 8.66983 3.29526L8.67062 3.29601Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56382 10.1812C8.55042 10.3071 8.4417 10.4042 8.31012 10.4164L6.49879 10.5848C6.368 10.5969 6.24115 10.5218 6.20333 10.4004C6.186 10.3466 6.17339 10.2912 6.16473 10.2335C6.16236 10.2176 6.1663 10.2017 6.17655 10.1888C6.18679 10.1759 6.20176 10.1683 6.2183 10.1668L8.50394 9.95436C8.52049 9.95284 8.53624 9.95815 8.54885 9.96801C8.56145 9.97863 8.56855 9.99305 8.56933 10.009C8.5717 10.0666 8.57012 10.1243 8.56461 10.1804L8.56382 10.1812Z",
    fill: "#EEFDFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55652 10.1816C8.499 10.7225 8.05228 11.1671 7.46846 11.221C6.89331 11.2748 6.37331 10.9312 6.20312 10.4221C6.24882 10.5306 6.36779 10.5974 6.49149 10.5852L8.30361 10.4176C8.4344 10.4047 8.54312 10.3083 8.55652 10.1824V10.1816Z",
    fill: "#AA0433"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4183 14.0987C11.4183 14.1146 11.4183 14.1298 11.4183 14.145C11.4128 14.2914 11.3773 14.4014 11.36 14.4507C10.8613 15.9171 10.5627 16.6909 10.1435 17.3168C10.071 17.4245 9.99539 17.5284 9.91345 17.6301C9.8063 17.7659 9.68891 17.8986 9.55891 18.0352C9.26976 18.3386 8.8317 18.476 8.69067 18.523C8.17461 18.6982 7.71842 18.6664 7.41588 18.6694H7.36309C7.05897 18.6664 6.60358 18.699 6.0883 18.523C5.94727 18.476 5.50842 18.3386 5.22006 18.0352C4.4243 17.2015 4.11782 16.5081 3.41897 14.4507C3.40242 14.4037 3.36933 14.3013 3.36145 14.164C3.35909 14.1245 3.3583 14.0843 3.36145 14.0449C3.37642 13.7991 3.48042 13.5578 3.664 13.3378C3.97915 12.96 4.46527 12.7529 4.96794 12.7514L7.39145 12.7415L9.77085 12.7324C10.2845 12.7302 10.7825 12.938 11.1087 13.3204C11.2662 13.5055 11.3671 13.7058 11.4041 13.9121C11.4088 13.9417 11.4136 13.9713 11.4167 14.0009C11.4199 14.0335 11.4215 14.0661 11.4215 14.0995L11.4183 14.0987Z",
    fill: "#D2042D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38156 12.7406L4.95805 12.7504C4.45538 12.7527 3.96847 12.9598 3.65411 13.3368C3.47053 13.5568 3.36653 13.7981 3.35156 14.0439C3.36417 13.792 3.47132 13.5439 3.66356 13.3194C3.98896 12.937 4.48768 12.7292 5.00138 12.7315L7.38156 12.7406Z",
    fill: "#AA0433"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79691 16.1791C9.76145 14.369 9.50697 14.011 9.882 13.5801C9.92533 13.5308 10.1452 13.2781 10.5068 13.2137C10.7952 13.1621 11.0567 13.2508 11.1804 13.3191C11.9328 13.7295 11.7091 15.5085 11.2143 16.6313C11.1064 16.8763 10.8164 17.5333 10.4635 17.5173C10.3185 17.5113 10.2121 17.3937 10.1373 17.3095C9.80557 16.9362 9.80242 16.4522 9.79691 16.1791Z",
    fill: "#D2042D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1406 17.3172C10.0681 17.4249 9.99246 17.5288 9.91052 17.6305C9.88452 17.6047 9.86167 17.5789 9.8404 17.5554C9.5087 17.1821 9.50555 16.6981 9.50003 16.425C9.46458 14.6149 9.21009 14.2569 9.58512 13.8267C9.6127 13.7949 9.71355 13.6796 9.87664 13.584C9.50634 14.0134 9.75846 14.3745 9.79391 16.1792C9.79864 16.4523 9.80337 16.9363 10.1343 17.3103C10.1366 17.3126 10.139 17.3149 10.1398 17.3172H10.1406Z",
    fill: "#AA0433"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1995 14.6713C11.1885 14.4771 11.1507 14.3337 11.075 14.0477C10.9758 13.6737 10.8513 13.4909 10.9324 13.4188C10.9852 13.3717 11.0884 13.4036 11.1121 13.4104C11.4674 13.5197 11.5777 14.1615 11.5619 14.5635C11.5525 14.8093 11.4902 15.0847 11.3965 15.0969C11.3815 15.0991 11.3453 15.0969 11.3185 15.0749C11.2137 14.9861 11.2074 14.82 11.1987 14.672L11.1995 14.6713Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.445 15.3584C11.445 15.3979 11.4119 15.4297 11.3709 15.4297C11.33 15.4297 11.2969 15.3979 11.2969 15.3584C11.2969 15.319 11.33 15.2871 11.3709 15.2871C11.4119 15.2871 11.445 15.319 11.445 15.3584Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_40011309_16249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23437 21.214C8.46839 21.214 9.46875 20.8622 9.46875 20.4283C9.46875 19.9944 8.46839 19.6426 7.23437 19.6426C6.00036 19.6426 5 19.9944 5 20.4283C5 20.8622 6.00036 21.214 7.23437 21.214Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_40011309_16249",
    x: 0,
    y: 14.6426,
    width: 14.4688,
    height: 11.5713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_40011309_16249"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40011309_16249",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.17245 8.01325) scale(1.35358 1.30331)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40011309_16249",
    x1: 4.34375,
    y1: 8.01324,
    x2: 5.99199,
    y2: 8.01324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_40011309_16249",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.86776 0.0378754) scale(1.35358 1.30331)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40011309_16249",
    x1: 8.03906,
    y1: -0.0000656659,
    x2: 9.68809,
    y2: -0.0000656659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFaceIcon);
export default __webpack_public_path__ + "static/media/chat-face-icon.9bbd43783868151c982fad4a38c9d97c.svg";
export { ForwardRef as ReactComponent };